import ENUMS from '../../../constants/enums';

export const options = {
  domestic: [
    ENUMS.SHIPPING_METHODS.ECONOMY,
    ENUMS.SHIPPING_METHODS.STANDARD,
    ENUMS.SHIPPING_METHODS.EXPRESS,
    ENUMS.SHIPPING_METHODS.ONE_DAY,
  ],
  international: [
    ENUMS.SHIPPING_METHODS.ECONOMY,
    ENUMS.SHIPPING_METHODS.STANDARD,
    ENUMS.SHIPPING_METHODS.EXPRESS,
  ],
};
export const config = {
  slidesToShow: 3,
  slidesToScroll: 1,
  formItemLayout: {
    colon: false,
    labelCol: { span: 6 },
    wrapperCol: { span: 7 },
  },
  shippingMethodColSpan: 7,
  editPolicyItemLayout: {
    colon: false,
    labelCol: { span: 7 },
    wrapperCol: { span: 10 },
  },
};
